/** Shared inset for grade/rank labels in search tiles and dictionary surface headers. */
export const SURFACE_STATS_SPACING_CLASS_NAME = "px-0.75 pb-0.5";
